import styles from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    icon: string;
}

export const Stamp = ({ icon, className, ...rest }: Props) => {
    return (
        <div className={`${styles.wrapper} ${className}`} {...rest}>
            <div className={`fa fa-${icon} ${styles.content}`} aria-hidden={true} />
        </div>
    );
};
